import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import StoriesSlider from './StoriesSlider'
import CollectionsTile from './CollectionsSlider'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import Typography from '@mui/material/Typography'
import SearchBox from '../../../components/SearchBox'
import { RouteComponentProps, useHistory } from 'react-router-dom'
import { StepStoryUploadContext } from '../../../components/StepStoryUpload'
import { StepInviteRecorderContext } from '../../../components/StepInviteRecorder'
import { CollectionTheme, CollectionType } from '../../../lib/types'
import { CreateEventContext } from '../../../components/CreateEvent'
import api from '../../../lib/api'
import { UserContext } from '../../../components/UserProvider'
import { capitalizeFirstLetter } from '../../../components/Capitalize'
import { usePermissions } from '../../../components/hooks/usePermissions'

const MyLibrary: React.FC<RouteComponentProps> = () => {
  const { actions: newStoryActions } = useContext(StepStoryUploadContext)
  const { actions: recorderActions } = useContext(StepInviteRecorderContext)
  const { actions: createEventActions } = useContext(CreateEventContext)
  const history = useHistory()
  const [themes, setThemes] = useState<CollectionTheme[]>([])
  const { member } = useContext(UserContext)
  const { isCreator } = usePermissions()

  const tenantsName = useMemo(() => {
    if (member && member.tenant) {
      const firstName = capitalizeFirstLetter(member.tenant.firstName)
      const lastName = capitalizeFirstLetter(member.tenant.lastName)
      return firstName + ' ' + lastName
    }
    return null
  }, [member])

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCallback = useCallback((_collection: CollectionType | null) => {
    // no-op
  }, [])

  useEffect(() => {
    const getThemes = async () => {
      try {
        const response = await api.getCollectionThemes()
        setThemes(response)
      } catch (e) {
        console.log(e)
      }
    }
    getThemes()
  }, [])

  const handleSearch = useCallback(
    (value: string) => history.push({ pathname: '/a/search', search: `q=${value}` }),
    [history]
  )

  const handleNewStory = useCallback(() => newStoryActions.open(), [newStoryActions])
  const handleRequestStories = useCallback(() => recorderActions.open(null), [recorderActions])
  const handleAddEvent = useCallback(
    () => createEventActions.open(handleCallback, undefined, themes),
    [createEventActions, handleCallback, themes]
  )

  return (
    <Grid
      container
      sx={{
        padding: '24px'
      }}
      spacing={4}
    >
      <Grid item xs={12}>
        <Typography variant="h6">{tenantsName ? tenantsName + `'s Library` : 'My Library'}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm>
            <SearchBox onSearch={handleSearch} />
          </Grid>
          <Grid item xs={12} sm minWidth={180} textAlign="right">
            <ButtonGroup sx={{ height: '54px' }} size="large" variant="outlined" disabled={!isCreator}>
              <Button onClick={handleNewStory}>Add a new story</Button>
              <Button onClick={handleRequestStories}>Request stories</Button>
              <Button onClick={handleAddEvent}>Add an event</Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <CollectionsTile q={''} />
      </Grid>
      <Grid item xs={12}>
        <StoriesSlider q={''} />
      </Grid>
    </Grid>
  )
}

export default MyLibrary
